import type { FC, MouseEvent } from 'react';
import { useIntl } from 'react-intl';

import { XING_JOBS_SEARCH_KI_PATH } from '@xing-com/crate-core-routes';
import { IconSearch } from '@xing-com/icons';
import { HorizontalNavMenu } from '@xing-com/platform-layout-horizontal-nav-menu';
import { SearchDropdownList } from '@xing-com/platform-search-dropdown';

import { NavItemHeader } from '../nav-item-header';

import * as Styled from './search-dropdown.styled';

export type SearchDropdownProps = {
  title: string;
};

export const SearchDropdown: FC = () => {
  const { formatMessage } = useIntl();

  return (
    <Styled.ButtonContainer>
      <HorizontalNavMenu
        tracking={{ PropTrackAction: 'navigation_search_drop_down' }}
        trigger={(onClick: (event: MouseEvent) => void) => (
          <NavItemHeader
            icon={IconSearch}
            activeIcon={IconSearch}
            href={`https://www.xing.com${XING_JOBS_SEARCH_KI_PATH}`}
            activeItemValues={['search']}
            title={formatMessage({ id: 'FRAME_HEADER_SEARCH' })}
            onClick={onClick}
          />
        )}
      >
        <SearchDropdownList />
      </HorizontalNavMenu>
    </Styled.ButtonContainer>
  );
};
